<script>
import { mapState, mapMutations } from "vuex";
import { get } from "lodash";
import LecturesMenu from "./LecturesMenu";
import config from "@/config/config";
import IsMobile from "@/service/IsMobile";
import Hls from "hls.js";

export default {
  name: "ComponentsCourseVideo",
  components: {
    LecturesMenu,
  },
  data() {
    return {
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
        controls: 1,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
        cc_load_policy: 0,
        cc_lang_pref: "en",
        wmode: "transparent",
        modestbranding: 1,
        disablekb: 1,
        origin: "https://wszystkozaczynasiewglowie.pl",
        enablejsapi: 1,
        widgetid: 1,
      },
      forceDesktop: false,
    };
  },
  computed: {
    ...mapState(config.app, ["course", "currentLectureIndex"]),
    lectures() {
      return get(this, "course.lectures", []);
    },
    lecture() {
      return !this.lectures[this.currentLectureIndex]
        ? {}
        : this.lectures[this.currentLectureIndex];
    },
    video() {
      return get(this, "lecture.video", {});
    },
    videoFile() {
      const desktopVideo = get(this, "lecture.video.video.url");
      const mobileVideo = get(this, "lecture.video.mobile.url");
      if (IsMobile() && mobileVideo && !this.forceDesktop) {
        return mobileVideo;
      }
      return desktopVideo;
    },
    isMobile() {
      return IsMobile();
    },
    isLast() {
      return this.currentLectureIndex >= this.lectures.length - 1;
    },
    hasExam() {
      return this.course.exam !== null;
    },
    flow() {
      return config.initial.course;
    },
  },
  methods: {
    ...mapMutations(config.app, [
      "setCurrentCourse",
      "setCurrentLectureIndex",
      "setCurrent",
    ]),
    next() {
      const nextIndex = this.currentLectureIndex + 1;

      if (this.lectures[nextIndex] && this.lectures[nextIndex].video) {
        this.setCurrentCourse(this.flow.video);
        this.setCurrentLectureIndex(nextIndex);

        let stream = get(this, "lecture.video.video.stream");
        let video = this.$refs["video"];

        if (Hls.isSupported()) {
          let hls = new Hls();
          hls.loadSource(stream);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, function () {
            video.play();
          });
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
          video.src = stream;
        }
        return;
      }

      if (this.isLast && this.course.finalWords !== null) {
        this.setCurrentCourse(this.flow.finish);
        return;
      }

      if (this.isLast && this.hasExam) {
        this.setCurrent(this.flow.exam);
        return;
      }

      this.setCurrentCourse(this.flow.lecture);
      this.setCurrentLectureIndex(0);
    },
    getVideoId() {
      const { video } = this;
      if (!video.videoUrl) {
        return null;
      }
      return this.$youtube.getIdFromUrl(video.videoUrl);
    },
    changeVideo() {
      let stream = get(this, "lecture.video.video.url");
      let video = this.$refs["video"];

      if (Hls.isSupported()) {
        let hls = new Hls();
        hls.loadSource(stream);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          video.play();
        });
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = stream;
      }
    },
  },
  mounted() {
    let stream = get(this, "lecture.video.video.url");
    let video = this.$refs["video"];

    if (Hls.isSupported()) {
      let hls = new Hls();
      hls.loadSource(stream);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, function () {
        video.play();
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = stream;
    }
  },
};
</script>
<style lang="scss" scoped>
video {
  max-width: 100%;
}

@media screen and (min-width: 576px) {
  video {
    height: 287px;
  }
}

@media screen and (min-width: 768px) {
  video {
    height: 388px;
  }
}

@media screen and (min-width: 992px) {
  video {
    height: 343px;
  }
}

@media screen and (min-width: 992px) {
  video {
    height: 411px;
  }
}
</style>
<template>
  <div id="course-video">
    <LecturesMenu />
    <div class="wrapper">
      <button class="btn w-auto" @click="setCurrentCourse(flow.lecture)">
        powrót
      </button>
      <div v-html="video.content" class="mt-5 mb-5" />
      <video width="100%" ref="video" controls></video>
      <button
        class="btn w-auto mt-5"
        @click="next()"
        v-if="!isLast || (isLast && course.finalWords !== null)"
      >
        Przejdź do następnego video
      </button>
      <button class="btn w-auto mt-5" @click="next()" v-if="isLast && hasExam">
        Przystąp do Egzaminu
      </button>
    </div>
  </div>
</template>
